import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDisclosure } from '@chakra-ui/react';
import { ButtonPrimary, Modal, colors } from '@aftersale-next/ui';
import * as trackingActions from '../../config/constants/tracking-actions';
import ReceivedConfirm from './confirms/received-confirm';
export default function ActionReceived(_ref) {
  var isLoading = _ref.isLoading,
      mutate = _ref.mutate,
      id = _ref.id,
      isError = _ref.isError,
      isSuccess = _ref.isSuccess,
      reset = _ref.reset;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var onConfirm = function onConfirm() {
    return mutate({
      action: trackingActions.RECEIVED,
      id: id
    });
  };

  var handleClose = function handleClose() {
    if (isLoading) return;
    if (isError) reset();
    onClose();
  };

  useEffect(function () {
    if (!isSuccess) return;
    onClose();
  }, [isSuccess, onClose]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonPrimary, {
      id: trackingActions.RECEIVED,
      disabled: isLoading,
      bgColor: colors.green,
      onClick: onOpen,
      children: t('ACTION_RECEIVED')
    }), /*#__PURE__*/_jsx(Modal, {
      isOpen: isOpen,
      onClose: handleClose,
      children: /*#__PURE__*/_jsx(ReceivedConfirm, {
        isLoading: isLoading,
        isError: isError,
        onClose: handleClose,
        onConfirm: onConfirm
      })
    })]
  });
}